import "./Loader.css"
const Loader = () => {

    return (
        <>
            {/* <div className="loading">
                <div className="spinner">
                </div>
            </div> */}
            <div class="circle-container">
                <div class="circle circle1"></div>
                <div class="circle circle2"></div>
            </div>
        </>
    )
}
export default Loader